import './style.scss'

import React, { Component } from 'react'

import Link from 'components/UI/Link'
import PropTypes from 'prop-types'
import SearchResultDropdownItem from 'components/Search/SearchResultDropdownItem'
import { connect } from 'react-redux'
import kebabCase from 'lodash/kebabCase'
import { push } from 'connected-react-router'
import { toggleSearchDropdown } from 'actions/UI'
import { withTranslation } from 'react-i18next'
import { resetFilterAndSort } from 'actions/Products'

const MAX_SEARCH_RESULTS = 5
const MAX_SUPPLIER_RESULTS = Math.floor(MAX_SEARCH_RESULTS / 2)
const MAX_PRODUCT_RESULTS = Math.ceil(MAX_SEARCH_RESULTS / 2)

export class SearchResultDropdown extends Component {
    handleClick(url) {
        this.props.dispatch(toggleSearchDropdown(false))
        this.props.dispatch(push(url))
    }

    countSuppliers(countResults) {
        const { suppliers, products } = this.props

        if (countResults > MAX_SEARCH_RESULTS) {
            return products.length < MAX_PRODUCT_RESULTS
                ? MAX_SEARCH_RESULTS - products.length
                : MAX_SUPPLIER_RESULTS
        } else {
            return suppliers.length
        }
    }

    render() {
        let { suppliers, products, query, t } = this.props
        const countResults = suppliers.length + products.length

        suppliers = suppliers.slice(0, this.countSuppliers(countResults))
        products = products.slice(0, MAX_SEARCH_RESULTS - suppliers.length)

        return (
            <div className="search-result-dropdown">
                {suppliers.map((supplier) => (
                    <SearchResultDropdownItem
                        key={supplier.id}
                        vendor={t('searchSearchResultDropdownSupplier')}
                        title={supplier.name}
                        onClick={() => this.handleClick(`/supplier/${supplier.id}`)}
                    />
                ))}

                {products.map((product) => {
                    let image
                    if (product.navigationImage && product.navigationImage.small) {
                        image = product.navigationImage.small
                    } else if (product.navigationImage && product.navigationImage.fullSize) {
                        image = product.navigationImage.fullSize
                    }
                    return (
                        <SearchResultDropdownItem
                            key={product.id}
                            vendor={product.vendor}
                            title={product.title}
                            image={image}
                            onClick={() =>
                                this.handleClick(
                                    `/product/${product.id}/${kebabCase(product.title)}`
                                )
                            }
                        />
                    )
                })}

                {countResults > MAX_SEARCH_RESULTS && (
                    <Link
                        className="search-result-dropdown__see-more"
                        to={`/search/${query}`}
                        onClick={() => {
                            this.props.dispatch(resetFilterAndSort())
                            this.props.dispatch(toggleSearchDropdown(false))
                        }}
                    >
                        {t('searchSearchResultDropdownMore', {
                            count: countResults - MAX_SEARCH_RESULTS,
                        })}
                    </Link>
                )}
            </div>
        )
    }
}

SearchResultDropdown.propTypes = {
    products: PropTypes.array,
    suppliers: PropTypes.array,
    query: PropTypes.string,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        products: state.search.autoCompleteResults.products,
        suppliers: state.search.autoCompleteResults.suppliers,
        query: state.search.query,
    }
}

export default connect(mapStateToProps)(withTranslation()(SearchResultDropdown))
